module.exports = __webpack_public_path__ + "img/logo-icon.9f4665ef.png";